<template>
  <div class="segment">
    <div class="title">
      {{ title }}
    </div>
    <radio-group :options="[{ value: true, text: 'Send to Subscribed Users'}, { value: false, text: 'Send to Particular Segment(s)'}]" v-model="sendToAll" />
    <div class="audience-group" :class="modelProp.sendToAll ? 'disabled' : ''">
      <div class="heading">
        SEND TO USERS IN SEGMENT
      </div>
      <div class="autocomplete-group">
        <autocomplete
            :search="search"
            :debounceTime="200"
            :get-result-value="item => item.name"
            @submit="result => autoCompleteSelection(true, result)"
            id="audience-autocomplete-included"
        />
        <div class="audience-chip" v-for="(audience, index) in modelProp.includedAudience" :key="audience.id || index">
          <span>{{ audience.name }}</span>
          <div class="delete-button" @click="() => removeAudienceSelection(true, index)"><i class="fas fa-minus-circle" /></div>
        </div>
      </div>
      <div class="heading">
        EXCLUDE USERS IN SEGMENT
      </div>
      <div class="autocomplete-group">
        <autocomplete
            :search="search"
            :debounceTime="200"
            :get-result-value="item => item.name"
            @submit="result => autoCompleteSelection(false, result)"
            id="audience-autocomplete-excluded"
        />
        <div class="audience-chip" v-for="(audience, index) in modelProp.excludedAudience" :key="audience.id || index">
          <span>{{ audience.name }}</span>
          <div class="delete-button" @click="() => removeAudienceSelection(false, index)"><i class="fas fa-minus-circle" /></div>
        </div>
      </div>
        <div  class="heading">
          SEND WITH LOOKER
          <i class="fas fa-info-circle" @mouseover="displayInfo('looker-info')" @mouseleave="removeInfo('looker-info')"></i>
        </div>
        <div id="looker-info" class="info">
          <pre>
          - Use this field in order to create your target users from your Looker analysis. 
          - You can use multiple filters to specify your audience, but make sure to have
            only user_id in your output table and the link that you submit is a “Look” link* 
            otherwise your message won’t be sent to your selected users.
          - Make sure to add event time filter on your look if possible.
          -  Finally, click on “Set Audience”.
          - (*) After creating your explore, save it “As a Look”, copy Look link and paste it into the relevant field. 
          - The Look link that you will submit should look like this: https://codeway.cloud.looker.com/looks/590 
          </pre>        
        </div>
        <div  class="autocomplete-group">
        <div class="row" style="margin-left: 2px;">
        <input type="text" class="form-control" style="background-color: #3F3356; border-color: black; width: 19rem" id="basic-url" aria-describedby="basic-addon3" placeholder="Enter look link" v-model="lookerUrl">
        <button class="btn btn-sm btn-info mx-2" @click="setAudience(true)">
          Set audience
        </button>
        </div>
      </div>
      <div  class="heading">
        EXCLUDE USERS WITH LOOKER
      </div>
      <div  class="autocomplete-group">
        <div class="row" style="margin-left: 2px;">
        <input type="text" class="form-control" style="background-color: #3F3356; border-color: black; width: 19rem" id="basic-url" aria-describedby="basic-addon3" placeholder="Enter look link" v-model="excludedLookerUrl">
        <button class="btn btn-sm btn-info mx-2" @click="setAudience(false)">
          Exclude audience
        </button>
        </div>
      </div>
        
    </div>
    <input-group inline v-model="percentage" label="Percentage" placeholder="100" value-type="number" :min="1" :max="100" />
  </div>

</template>

<script>
import RadioGroup from "@/views/PushNotification/UIComponents/RadioGroup";
import Autocomplete from '@trevoreyre/autocomplete-vue'
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import {displayMixin} from "@/util/displayMixin.js"

export default {
  name: "index",
  mixins: [displayMixin],
  components: {
    InputGroup,
    RadioGroup,
    Autocomplete
  },
  model: {
    prop: "modelProp",
    event: "modelEvent"
  },
  props: {
    modelProp: Object,
    title: String
  },
  data(){
    return{
      lookerUrl:  "",
      excludedLookerUrl: ""
    }
  },
  computed: {
    audiences() {
      const audiences = this.$store.getters.audiences;
      if (audiences) return audiences;
      else return [];
    },
    sendToAll: {
      get() {
        return this.modelProp.sendToAll;
      },
      set(value) {
        const newModel = { ...this.modelProp, sendToAll: value };
        this.$emit('modelEvent', newModel);
      }
    },
    percentage: {
      get() {
        return this.modelProp.percentage;
      },
      set(value) {
        const newModel = { ...this.modelProp, percentage: value };
        this.$emit('modelEvent', newModel);
      }
    }
  },
  methods: {
    async setAudience(isIncluded){
      alert("Be sure to add event time filter on your look if possible.")
      const fields = isIncluded ? this.lookerUrl.split('/') : this.excludedLookerUrl.split('/')
      const lookId = fields[fields.length -1]

      // Create a new audience object each time to avoid reference issues
      const newLookerAudience = {
        id: this.makeId(20),
        name: "Look " + lookId,
        created_at: Date.now(),
        conditions: [{operator: "in", key: "user_id", value: lookId, isQuery: true}],
        description: "query that returns user_id's in given look",
        percentage: 100,
        update_time: Date.now(),
      };

      const newAudiences = isIncluded ? [...this.modelProp.includedAudience] : [...this.modelProp.excludedAudience]
      newAudiences.push(newLookerAudience)

      const newModel = {
        ...this.modelProp,
        isLookerPush: true,
        [isIncluded ? 'includedAudience' : 'excludedAudience']: newAudiences
      };
      this.$emit('modelEvent', newModel);
    },
    makeId(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
    }
    return result;
    },
    search(input) {
      if(input.length < 1) {
        return []
      } else {
        return this.audiences.filter(item => item.name.toLowerCase().includes(input.toLowerCase()))
      }
    },
    autoCompleteSelection(isIncluded, result) {
      const newAudiences = isIncluded ? [...this.modelProp.includedAudience] : [...this.modelProp.excludedAudience]
      if(newAudiences.indexOf(result) === -1) {
        newAudiences.push(result)
      }
      const newModel = { ...this.modelProp, [isIncluded ? 'includedAudience' : 'excludedAudience']: newAudiences }
      this.$emit('modelEvent', newModel)
      const autocompleteId = "audience-autocomplete-" + (isIncluded ? 'included' : 'excluded')
      document.getElementById(autocompleteId).value = ""
    },
    removeAudienceSelection(isIncluded, index) {
      const newAudiences = isIncluded ? [...this.modelProp.includedAudience] : [...this.modelProp.excludedAudience]
      newAudiences.splice(index, 1);
      const newModel = { ...this.modelProp, [isIncluded ? 'includedAudience' : 'excludedAudience']: newAudiences }
      this.$emit('modelEvent', newModel)
    }
  }
}
</script>

<style scoped>
.segment {
  background-color: rgba(44, 44, 71, 0.46);
  margin: 30px 0;
  border-radius: 3px;
  padding: 20px 20px;
  color: white;
  font-size: 16px;
  font-weight: 400;

}
.title {
  font-size: 24px;
  font-weight: 500;
}

.audience-group {
  margin-left: 50px;
  margin-top: 20px;
  position: relative;
  display: inline-block;
  padding: 5px;
}

.audience-group .heading {
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;

  color: #949CC9;
}

.autocomplete-group {
  display: flex;
  margin: 5px 0;
}

.audience-chip {
  border-radius: 16px;
  background: #3F3356;
  padding: 2px 10px;
  display: flex;
  align-items: center;
  margin: 5px 10px;
}

.audience-chip span {
  font-size: 12px;
  margin: 0 5px;
}
.delete-button {
  cursor: pointer;
}

>>> .autocomplete-input {
  background-color: #3F3356;
  color: white;
  font-size: 14px;
}

>>> .autocomplete-result-list {
  background-color: #3F3356;
  color: white;
}

>>> .autocomplete-result-list .autocomplete-result {
  color: white!important;
  font-size: 14px!important;
}

.audience-group.disabled {
  pointer-events: none;
  display: none;
}



</style>